import * as z from "zod";

export const resetBillingAutoReloadDisabled = {
  name: "resetBillingAutoReloadDisabled" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
